<div class="d-flex justify-content-start align-items-center search-input-container">
    <input #searchInput type="search" class="form-control ps-35" placeholder="Search for users" (keyup)="onSearchStringChange($event)" />
    <span class="position-absolute icon-search ps-10"></span>
</div>
<div class="d-flex justify-content-start align-items-center my-20 search-filter-container">
    <div class="position-relative">
        <button class="filter-button payment-type-btn d-flex justify-content-center align-items-center" [ngClass]="{'active': isFilterActive('paymentType')}">
            Payment type <span class="fas fa-chevron-down ms-0_5"></span>
        </button>
        <div class="payment-type-fiter-content px-20 py-10 position-absolute">
            <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onPaymentTypeSelect('prepaid')">
                <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="paymentTypeFilter === 'prepaid'" />
                </div>
                <span>Prepaid</span>
            </div>
            <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onPaymentTypeSelect('postpaid')">
                <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="paymentTypeFilter === 'postpaid'" />
                </div>
                <span>Postpaid</span>
            </div>
        </div>
    </div>

    <div class="position-relative">
        <button class="filter-button owner-btn d-flex justify-content-center align-items-center ms-10" [ngClass]="{'active': isFilterActive('owner')}">
            Owner <span class="fas fa-chevron-down ms-0_5"></span>
        </button>
        <div class="owner-filter-content py-20 position-absolute">
            <div class="mx-10">
                <input [(ngModel)]="owner" type="text" class="form-control owner-input" placeholder="Enter owner email or username" />
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onOwnerClear()">Clear</button>
                <button class="btn btn-primary" (click)="onOwnerSubmit()">Submit</button>
            </div>
        </div>
    </div>

    <div class="cp ms-10" (click)="onClearAllFilters()">
        <span class="far fa-trash-alt"></span>
        <span class="ms-0_5">Clear filters</span>
    </div>
</div>

<div class="mt-5">
    <div class="users-table-container">
        <div [hidden]="!loading" class="spinner h-50">
            <div class="sk-spinner sk-spinner-pulse"></div>
        </div>
        <ag-grid-angular style="width: 100%; height: 100%" class="ag-theme-alpine" rowSelection="multiple" rowHeight="48" rowMultiSelectWithClick="true"
            suppressRowClickSelection="false" suppressDragLeaveHidesColumns="true" suppressMenuHide="true" enableCellTextSelection="true" [icons]="customIcons"
            [columnDefs]="columnDefs" [tooltipShowDelay]="500" [defaultColDef]="defaultColDef" [paginationPageSize]="paginationPageSize" [pagination]="true"
            [suppressPaginationPanel]="true" [suppressCellSelection]="true" [isExternalFilterPresent]="isExternalFilterPresent" [getRowId]="getRowId"
            [doesExternalFilterPass]="doesExternalFilterPass" [suppressScrollOnNewData]="true" [rowData]="rowData"
            (selectionChanged)="onSelectionChanged($event)" (gridReady)="onGridReady($event)"></ag-grid-angular>
    </div>
</div>
